
import { InputTextarea } from 'primereact/inputtextarea'; 
import { classNames } from 'primereact/utils';
import React, { useEffect, useRef, useState } from 'react';

/**
 * A customizable textarea input template
 */
const TextareaInputTemplate = ({
    name,
    label,
    disabled,
    className,
    labelClassName,
    floatLabel,
    noMargins,
    bottomMargin,
    inline,
    value,
    placeholder,
    onChangeFunction,
    isValid,
    errorMessage,
    focusInput,
    selectInput,
    category,
    rows,
    cols
}) => {
    const inputRef = useRef();
    const [inputClasses, setInputClasses] = useState(classNames({ 
        'p-invalid': isValid, 
        'w-full': true 
    }));
    const [labelClasses, setLabelClasses] = useState(classNames({ 
        'p-error': isValid,
        'w-full': true,
        'block mb-2': !inline, 
        'mr-2': inline  
    }));

    useEffect(() => {
        // add input classes (if we have any)
        if (className) {
            setInputClasses(inputClasses + ' ' + className);
        }

        // add label classes (if we have any)
        if (labelClassName) {
            setLabelClasses(labelClasses + ' ' + labelClassName);
        }

        // focus on input on load
         if (focusInput) {
            inputRef.current.focus();
        }

        // select all input on load
        if(selectInput) {
            inputRef.current.select();
        }
    }, []);

    const inputField = <InputTextarea id={name} value={value} 
        disabled={disabled}
        placeholder={placeholder} 
        onChange={(e) => onChangeFunction(name, e.target.value, category)} 
        className={inputClasses} 
        rows={rows || 5}
        cols={cols || 50}
        ref={inputRef}
    />;

    return (
        <div className={!noMargins ? ('mb-' + (bottomMargin || '5')) : ''}>
            {floatLabel
                ?<> 
                    <span className="p-float-label">
                        {inputField}
                        <label htmlFor={name} className={labelClasses}>{label}</label>              
                    </span>

                    {errorMessage}
                </>

                : <>
                    <label htmlFor={name} className={labelClasses} title={ labelClassName == 'one-line' ? label : null }>{label}</label>
                    {inputField}
                    {errorMessage}
                </>
            }            
        </div>
    );
};

export default TextareaInputTemplate;